import {
  takeLatest, put,
} from 'redux-saga/effects';
import * as types from './types';
import * as actions from './actions';

function* initRequest() {
  yield put(actions.init());
}

function* watchInitRequest() {
  yield takeLatest(types.INIT, initRequest);
}

export default [
  watchInitRequest,
];
